import Alpine from 'alpinejs'

// Optional: you can register plugins here
// import focus from '@alpinejs/focus'
// Alpine.plugin(focus)

// Set Alpine to window if you want access in console
window.Alpine = Alpine

// Start Alpine
Alpine.start()